export default "__VITE_ASSET__CZQ6_DPk__"